import { render, staticRenderFns } from "./group-list.vue?vue&type=template&id=48b24980&scoped=true"
import script from "./group-list.vue?vue&type=script&lang=js"
export * from "./group-list.vue?vue&type=script&lang=js"
import style0 from "./group-list.vue?vue&type=style&index=0&id=48b24980&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b24980",
  null
  
)

export default component.exports